import gql from 'graphql-tag'

export const VALIDATE_TOKEN = gql`
  query checkAccessToken($accessToken: String) {
    checkAccessToken(accessToken: $accessToken) {
      person {
        tutors(status: ACTIVE) {
          id
        }
        roles(status: ACTIVE) {
          id
        }
      }
    }
  }
`

export interface ICheckAccessToken {
  data: {
    checkAccessToken: {
      token: string
      person: {
        tutors: { id: string }[]
        roles: { id: string }[]
      }
    }
  }
  error?: string
}
